import { useNavigate } from "@tanstack/react-router";
import { Plus } from "lucide-react";

import { Button } from "@components/ui/button";

import { CAPABILITIES } from "@constants/capabilities";
import { NAVIGATION_PATHS } from "@constants/navigation";

import { useCapabilities } from "@hooks/queries/use-me";

import { CreateCaseModal } from "./CreateCaseModal";

/**
 * Case creation entry point (access levels v1 + MDRS-157). Gated on
 * CASES_CREATE — the backend's actual enforcement (api/cases/handler.py) — so
 * disabling "Create cases" in Access Configuration hides this for every user
 * type, doctor included. REPORT_BUILDER just picks which UI renders: doctors
 * get the template-based create modal, referrers get the "New case" page
 * (the 4-step wizard).
 */
export const CreateCaseAction = () => {
  const navigate = useNavigate();
  const { can } = useCapabilities();

  if (!can(CAPABILITIES.CASES_CREATE)) return null;

  if (can(CAPABILITIES.REPORT_BUILDER)) return <CreateCaseModal />;

  return (
    // Button's default variant is already navy; just add the CTA drop shadow
    // the design gives prominent page-level actions.
    <Button
      className="shadow-[0_6px_16px_rgba(26,25,57,0.22)]"
      onClick={() => navigate({ to: NAVIGATION_PATHS.NEW_CASE })}
    >
      <Plus className="mr-2 h-4 w-4" />
      New case
    </Button>
  );
};
